// export const Base_URL = `http://localhost:8080`;

export const Base_URL = `https://stagingbackend.swiftuni.com`;
// export const Base_URL = `https://backend.swiftuni.com`;

export const Base_URL_AiScore = `https://aiscorer.swiftuni.com`;
